import { api } from '../../../AxiosConfig';

function fileToDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject(new Error('Falha ao ler o arquivo.'));
        reader.readAsDataURL(file);
    });
}

export class ClientGalleryService {
    list(clientId: string) {
        return api.get(`/clients/${clientId}/gallery`);
    }

    async upload(clientId: string, file: File, description?: string) {
        const dataUrl = await fileToDataUrl(file);

        const base64Pattern = /^data:(.*?);base64,(.*)$/;
        const match = dataUrl.match(base64Pattern);
        if (!match) throw new Error('Base64 inválido.');

        const fileType = match[1];
        const fileContent = match[2];

        return api.post(`/clients/${clientId}/gallery/upload`, {
            size: file.size,
            fileType,
            appId: 'client-gallery',
            fileName: file.name,
            lastModifiedDate: file.lastModified,
            fileContent,
            description,
        });
    }

    remove(clientId: string, mediaId: string) {
        return api.delete(`/clients/${clientId}/gallery/${mediaId}`);
    }
}
